<template>
  <VListItem
    :active="active"
    :value="value"
    :href="href"
    :to="to"
    :density="density"
    class="ui-list-item"
  >
    <template v-if="$slots['prepend']" #prepend>
      <slot name="prepend" />
    </template>
    <slot />
    <template v-if="$slots['append']" #append>
      <slot name="append" />
    </template>
    <div v-if="active" class="ui-list-item-children">
      <slot name="children"></slot>
    </div>
  </VListItem>
</template>

<script setup lang="ts">
import { VListItem } from 'vuetify/components/VList';
import { computed } from 'vue';

export interface Props {
  value?: string | number;
  href?: string;
  to?: string;
  active?: boolean;
  density?: 'default' | 'comfortable' | 'compact';
  color?: string;
}

const {
  color = undefined,
  density = 'default',
  value = undefined,
  href = undefined,
  to = undefined,
  active = false,
} = defineProps<Props>();

const textColor = computed(() => {
  if (color === undefined) return 'inherit';
  return `rgb(var(--v-theme-${color}))`;
});
</script>

<style lang="scss" scoped>
:deep(.v-list-item__append .v-icon) {
  opacity: 1;
}

.ui-list-item {
  color: v-bind(textColor);

  &:hover {
    background-color: rgb(var(--v-theme-bg-primary));
  }
}

.ui-list-item-children {
  position: absolute;
  top: 0;
  right: -50%;
}
</style>
